import React, { useEffect } from 'react';

// A non-blocking notification component that appears at the bottom of the screen.
export default function Toast({ message, type, onDismiss }) {
    useEffect(() => {
        const timer = setTimeout(() => {
            onDismiss();
        }, 3000); // Automatically dismiss after 3 seconds

        return () => clearTimeout(timer);
    }, [onDismiss]);

    const baseClasses = "fixed bottom-5 left-1/2 -translate-x-1/2 max-w-sm w-11/12 p-4 rounded-xl shadow-lg text-white font-semibold text-center z-50 animate-fade-in-out";
    
    const typeClasses = {
        success: "bg-green-500",
        error: "bg-red-500",
        info: "bg-sky-500",
    };

    return (
        <div className={`${baseClasses} ${typeClasses[type] || typeClasses.info}`}>
            {message}
            <style>{`
                @keyframes fade-in-out {
                    0% { opacity: 0; transform: translate(-50%, 20px); }
                    10% { opacity: 1; transform: translate(-50%, 0); }
                    90% { opacity: 1; transform: translate(-50%, 0); }
                    100% { opacity: 0; transform: translate(-50%, 20px); }
                }
                .animate-fade-in-out {
                    animation: fade-in-out 3s ease-in-out forwards;
                }
            `}</style>
        </div>
    );
}
